export class EmailConst {
  static displayColumns = () => {
    return [
      {
        title: 'Tên tài khoản',
        key: 'ACCOUNT_NAME',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Địa chỉ email',
        key: 'EMAIL_ADDRESS',
        display: true,
        allowSort: false,
        classes: '',
      },
    ];
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/conversation/email/email.const.ts